import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { DataService } from '@app/_services/data.service';
import { LegalEntity } from '@app/_models/_DTOs/legalEntity';

@Injectable({ providedIn: 'root' })
export class LegalEntityService extends DataService<LegalEntity> {
    constructor(http: HttpClient) {
        super(http, "api/LegalEntity");
    }
}